<template >
  <!-- 停水事件详情 -->
  <a-modal
    title="停水事件详情"
    width="50%"
    v-model="addOrUpdateVisible"
    @ok="addOrUpdateVisible = false"
    @cancel="addOrUpdateVisible = false"
  >
    <a-row class="Details-row" type="flex" justify="center" :gutter="4">
      <a-col :md="12" :sm="24"> 事件编号：{{ DetailsData.eventNo }}</a-col>
      <a-col :md="12" :sm="24"> </a-col>
      <a-col :md="12" :sm="24">事件名称：{{ DetailsData.eventName }} </a-col>
      <a-col :md="12" :sm="24"></a-col>
      <a-col :md="12" :sm="24"> 管段信息： <a-button type="primary" @click="openMap">点击查看管道</a-button></a-col>
      <a-col :md="12" :sm="24"> </a-col>
      <a-col :md="12" :sm="24"> 开始分类编号：{{ DetailsData.startClassNo }}</a-col>
      <a-col :md="12" :sm="24">结束分类编号：{{ DetailsData.endClassNo }} </a-col>
      <a-col :md="12" :sm="24"> 计划停水开始时间：{{ DetailsData.planStartTime }}</a-col>
      <a-col :md="12" :sm="24">计划停水结束时间：{{ DetailsData.planEntTime }} </a-col>
      <a-col :md="12" :sm="24"> 事件管理员：{{ DetailsData.adminName }}</a-col>
      <a-col :md="12" :sm="24">事件负责人：{{ DetailsData.principalName }} </a-col>
      <a-col :md="12" :sm="24"> 停水管理员：{{ DetailsData.waterAdminName }}</a-col>
      <a-col :md="12" :sm="24">
        事件状态： <span v-if="DetailsData.status === 0">未处理</span>
        <span v-if="DetailsData.status === 1">已处理</span></a-col
      >
      <a-col :md="24" :sm="24" style="margin-top: 15px">描述：{{ DetailsData.describe }} </a-col>
      <a-col :md="24" :sm="24" style="margin-top: 15px"
        >附件：
        <div class="fileDiv">
          <ul>
            <li class="fileLi" v-for="item in DetailsData.fileNames" :key="item.url">
              <!-- <img :src="item.url" alt="" style="width: 50px; height: 50px" /> -->
              <div class="uploadDiv" @click="uploadFile(item)">
                <a-icon type="file-done" style="cursor: pointer" />
                {{ item.name }}
              </div>
              <!-- <a-icon type="delete" style="float: right; cursor: pointer" @click="deleteFile(item.url)" /> -->
            </li>
          </ul>
        </div></a-col
      >
    </a-row>
    <a-modal class="log-form" :title="'选取位置'" width="50%" v-model="showMap" @ok="closeMap" @cancel="closeMap">
      <input class="login-input" type="text" v-model="startLine" placeholder="请输入开始分类编码" />
      <input class="login-input" type="text" v-model="endLine" placeholder="请输入结束分类编码" />
      <a-button type="submit" @click="searchMapLine">查询</a-button>
      <mapTemplate ref="waterMap"></mapTemplate>
    </a-modal>
  </a-modal>
</template>

<script>
import dayjs from 'dayjs'
import mapTemplate from '@/views/Water-outage-control/map-template.vue'
export default {
  components: {
    dayjs,
    mapTemplate,
  },
  data() {
    return {
      startLine: '',
      endLine: '',
      showMap: false,
      confirmLoading: false,
      addOrUpdateVisible: false,
      DetailsData: [],
    }
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    DetailsHandle(item) {
      this.DetailsData = item
      this.addOrUpdateVisible = true
    },
    openMap() {
      this.showMap = true
      this.$refs.waterMap.redSource.clear()
      this.startLine = this.DetailsData.startClassNo || ''
      this.endLine = this.DetailsData.endClassNo || ''
      if (this.startLine.length > 0 || this.endLine.length > 0) {
        this.$nextTick(() => {
          this.$refs.waterMap.searchLines(this.startLine, this.endLine)
        })
      }
    },
    closeMap() {
      this.startLine = ''
      this.endLine = ''
      this.showMap = false
      this.$refs.waterMap.redSource.clear()
    },
    closeMap2() {
      this.showMap = false
      this.startLine = ''
      this.endLine = ''
      this.$refs.waterMap.redSource.clear()
    },
    searchMapLine() {
      this.$refs.waterMap.searchLines(this.startLine, this.endLine)
    },
  },
}
</script>

<style lang="less" scoped>
/deep/.Details-row > .ant-col-md-12 {
  display: block;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 50%;
  margin-top: 20px;
}
</style>
